import React, { Fragment, forwardRef, useState, useEffect } from "react";
import { Skeleton, Card, Icon, Avatar, Col, Row, message, Spin } from 'antd';
import Meta from 'antd/es/card/Meta';
import clsx from 'clsx';
import './styles.css';
import { isActive } from 'lib';

function LoadingSpinner() {
  return (
    <Card loading={false}>
      <Row style={{ width: '100%', height: '20vh', }}
           type="flex" justify="center" align="middle">
        <Col>
          <Spin size="large" />
        </Col>
      </Row>
    </Card>
  )
}

export default forwardRef((props: any, ref: any) => {
  const {
    src,
    title,
    setActiveButton,
    index,
    activeButton,
    correctAnswer,
    checkAnswer,
    ...rest
  } = props;
  const [loading, setLoading] = useState(true);
  const [image, setImage] = useState(new Image());

  useEffect(() => {
    if (src) {
      let isMounted = true; // prevent state changes after unmount

      if (isMounted) setLoading(true);

      const image = new Image();
      image.height = 100;
      image.src = src;
      image.decode()
      .then(() => {
        if (isMounted) {
          setLoading(false);
          setImage(image)
        }
      })
      .catch((error) => {
        message.error(error.message);
        console.error(error, error.toString())
      });

      return () => { isMounted = false }; // prevent state changes after unmount
    }
  }, [src]);

  return (
    <Fragment>
    { src && loading && <LoadingSpinner /> }
    { src && !loading && (
      <Avatar
        className={clsx('tile-image', {
          'active': activeButton === index,
          'correct': checkAnswer && correctAnswer,
          'incorrect': checkAnswer && (activeButton === index) && !correctAnswer,
        })}
        onClick={setActiveButton}
        shape="square"
        style={{
          width: '40vmin',
          height: '30vmin',
        }}
        src={image.src}
      />
    )}
    { !src && (
      <Avatar
        className={clsx('tile-text', {
          'active': activeButton === index,
          'correct': checkAnswer && correctAnswer,
          'incorrect': checkAnswer && (activeButton === index) && !correctAnswer,
        })}
        onClick={setActiveButton}
        shape="square"
        style={{
          width: '40vmin',
          height: '30vmin',
        }}
      />
    )}
    </Fragment>
  )
});